import { Button, Container, Grid, Typography } from '@mui/material';
import {Topbar, Page, SnackBarContext } from 'components';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Services } from 'types';
import { MainSidebar } from '../views';
import client from '../feathers';
import { utils, writeFileXLSX } from "xlsx"
import { LoadingSpinner } from 'assets/svg/loadingSpinner';

export interface IStatisticsProps { }

/**
 * Evaluations section for analysts where course evaluations can be downloaded
 *
 * @type Analyst
 */

export const Evaluations = observer((props: IStatisticsProps) => {
  const { t } = useTranslation();
  const [downloading, setDownloading] = React.useState<boolean>(false);
  const { toast }   = React.useContext(SnackBarContext);

  const handleClick = async () => {
    setDownloading(true)
    try {
      const data = await client.service(Services.Evaluation).export({})
      const worksheet = utils.json_to_sheet(data);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "Data");
      writeFileXLSX(workbook, "kursbetyg.xlsx", { compression: true });
    } catch(error) {
      console.log(error)
      toast(t("evaluations_download_failed"), "error");
    }
    setDownloading(false);
  }

  return (
    <Page sidebar={<MainSidebar />} topbar={<Topbar />}>
      <Container sx={{padding:{xs: 4}, maxWidth:{lg: 'lg'}}}>
        <Grid
          item
          xs             = {12}
          mb             = {3}
          display        = 'flex'
          justifyContent = 'space-between'
        >
          <Typography variant='h2'>{t('courses_evaluations')}</Typography>
          <Button variant='contained' onClick={handleClick}>
            {downloading ? <LoadingSpinner height={20} width={20} /> : t('download_file')}
          </Button>
        </Grid>
        <Grid xs={12} mb={3} item>
          <Typography variant='body1'>
            {t('courses_evaluations_info')}
          </Typography>
        </Grid>  
      </Container>
    </Page>
  );
});
